<template>
  <EditDialog
    :visible="visible"
    :title="$t('organization_structure.edit_sites_group')"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-form
        v-if="form.sitesGroup._id"
        v-model="form.valid"
        ref="edit_sitesGroup_form"
      >
        <v-text-field
          required
          outlined
          dense
          data-private
          autofocus
          v-model="form.sitesGroup.name"
          :disabled="loading"
          :hideDetails="Boolean(form.sitesGroup.name)"
          :class="Boolean(form.sitesGroup.name) ? 'mb-4' : ''"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
          :label="`${$t('groups.group_name')}*`"
        />
        <MultipleSelect
          hideDetails
          class="mb-4"
          :label="$t('common.site_other')"
          :value="form.sitesGroup.sites"
          :options="sitesOptions"
          :loading="fetching"
          :disabled="loading"
          @search="getSites"
          @change="form.sitesGroup.sites = $event"
        />
        <div class="d-flex align-center">
          <p class="blue-grey--text text--darken-3 ma-0 pa-0 me-2 body-1">
            {{ $t('common.enabled') }}
          </p>
          <v-switch
            class="mt-0 pt-0"
            hide-details
            v-model="form.sitesGroup.isEnabled"
            :disabled="loading"
            :ripple="false"
          />
        </div>
      </v-form>
    </template>
    <template v-slot:footer>
      <div>
        <v-btn
          text
          class="me-4"
          :disabled="loading"
          color="blue-grey"
          @click="$emit('close')"
          >{{ $t('common.button.cancel') }}</v-btn
        >
        <v-btn
          rounded
          color="blue"
          elevation="0"
          class="white--text"
          :loading="loading"
          :disabled="loading"
          @click="handleSave"
          >{{ $t('common.button.save') }}</v-btn
        >
      </div>
    </template>
  </EditDialog>
</template>

<script>
import MultipleSelect from '@/components/Core/MultipleSelect.vue'

import EditDialog from '@/containers/OrganizationStructureView/Shared/EditDialog.vue'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'EditSitesGroupDialog',

  mixins: [mixin],

  components: {
    MultipleSelect,
    EditDialog,
  },

  props: {
    organizationId: String,
    loading: Boolean,
    visible: Boolean,
    sitesGroup: {
      type: Object,
      required: false,
      default: () => {
        return { name: '', sites: [], id: '' }
      },
    },
  },

  data() {
    return {
      fetching: false,
      sites: [],
      form: {
        valid: true,
        sitesGroup: {
          name: '',
          sites: [],
          id: '',
        },
      },
    }
  },

  watch: {
    visible(visible) {
      if (!visible) this.resetForm()
    },

    sitesGroup(newVal) {
      this.form.sitesGroup = {
        ...newVal,
      }
    },
  },

  mounted() {
    this.getSites()
  },

  computed: {
    sitesOptions() {
      return this.sites?.filter?.(site => site.isEnabled) ?? []
    },
  },

  methods: {
    async getSites(terms) {
      this.fetching = true
      const payload = {
        limit: 100,
        sortBy: 'updatedAt',
        sortOrder: 'desc',
        from: 0,
      }

      if (terms) payload.terms = terms
      try {
        const response = await api.site.getStreamSites(
          this.organizationId,
          payload
        )

        this.sites = response?.data.results.map(item => item?.site) ?? []
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.fetching = false
      }
    },

    handleSave() {
      this.$refs.edit_sitesGroup_form.validate()
      if (!this.form.valid) return
      this.$emit('save', this.form.sitesGroup)
    },

    resetForm() {
      this.form.sitesGroup = {
        name: '',
        sites: [],
        id: '',
      }
      this.$refs?.edit_sitesGroup_form?.reset?.()
    },
  },
}
</script>
